export enum TransitionalCareStatusEnum {
    Active = 1,
    Closed = 2,
}
